// App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login/Login";
import Layout from "./pages/Layout/Layout";
import Profile from "./components/Profile/Profile";
import DownloadReportPage from "./components/DownloadReportPage/DownloadReportPage";
import DownloadCertificationReportPage from "./components/DownloadReportPage/DownloadCertificationReportPage";
import EditProfile from "./components/ProfileEdit/ProfileEdit";
import Infrastructure from "./components/LabMapping/Infrastructure/Infrastructure";
import Reports from "./components/LabMapping/Reports/Reports";
import Biosafety from "./components/LabMapping/Biosafety/Biosafety";
import LogisticsSupplyChain from "./components/LabMapping/LogisticsSupplyChain/LogisticsSupplyChain";
import QualityManagementSystem from "./components/LabMapping/QualityManagementSystem/QualityManagementSystem";
import SLIPTAchecklist from "./components/SLIPTAchecklist/SLIPTAchecklist";
import AuditSummary from "./components/SLIPTAchecklist/AuditSummary/AuditSummary";
import OrganizationLeadership from "./components/SLIPTAchecklist/OrganizationLeadership/OrganizationLeadership";
import PersonnelManagement from "./components/SLIPTAchecklist/PersonnelManagement/PersonnelManagement";
import CustomerFocus from "./components/SLIPTAchecklist/CustomerFocus/CustomerFocus";
import EquipmentManagement from "./components/SLIPTAchecklist/EquipmentManagement/EquipmentManagement";
import InventoryManagement from "./components/SLIPTAchecklist/InventoryManagement/InventoryManagement";
import ProcessManagement from "./components/SLIPTAchecklist/ProcessManagement/ProcessManagement";
import InformationManagement from "./components/SLIPTAchecklist/InformationManagement/InformationManagement";
import NonConformingEvents from "./components/SLIPTAchecklist/NonConformingEvents/NonConformingEvents";
import ContinualImprovement from "./components/SLIPTAchecklist/ContinualImprovement/ContinualImprovement";
import FacilitiesSafety from "./components/SLIPTAchecklist/FacilitiesSafety/FacilitiesSafety";
import AccreditationA from "./components/AccreditationA/AccreditationA";
import AccreditationB from "./components/AccreditationB/AccreditationB";
import LabDetailsLayout from "./components/LabDetailsLayout/LabDetailsLayout";
import Introduction from "./components/AccreditationA/Introduction/Introduction";
import GeneralRequirements from "./components/AccreditationA/GeneralRequirements/GeneralRequirements";
import PreExaminationProcess from "./components/AccreditationA/PreExaminationProcess/PreExaminationProcess";
import ResourceRequirements from "./components/AccreditationA/ResourceRequirements/ResourceRequirements";
import GovernanceRequirements from "./components/AccreditationA/GovernanceRequirements/GovernanceRequirements";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "./pages/NotFound/NotFound";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Unauthorized from "./pages/Unauthorized/Unauthorized";
import SpecimenReferral from "./components/LabMapping/SpecimenReferral /SpecimenReferral";
import AddAuditSummary from "./components/SLIPTAchecklist/AuditSummary/AddAuditSummary/AddAuditSummary";
import DocumentsRecords from "./components/SLIPTAchecklist/DocumentsRecords/DocumentsRecords";
import AddDocumentsRecords from "./components/SLIPTAchecklist/DocumentsRecords/AddDocumentsRecords/AddDocumentsRecords";
import AddOrganizationLeadership from "./components/SLIPTAchecklist/OrganizationLeadership/AddOrganizationLeadership/AddOrganizationLeadership";
import AddPersonnelManagement from "./components/SLIPTAchecklist/PersonnelManagement/AddPersonnelManagement/AddPersonnelManagement";
import WeeklyReport from "./components/LabMapping/WeeklyReport/WeeklyReport";
import IntroductionB from "./components/AccreditationB/IntroductionB/IntroductionB";
import ReportsRequirements from "./components/AccreditationB/ReportsRequirements/ReportsRequirements";
import SampleReceipt from "./components/AccreditationB/SampleReceipt/SampleReceipt";
import RequestsExaminations from "./components/AccreditationB/RequestsExaminations/RequestsExaminations";
import ExaminationProcesses from "./components/AccreditationB/ExaminationProcesses/ExaminationProcesses";
import FacilitiesEnvironment from "./components/AccreditationB/FacilitiesEnvironment/FacilitiesEnvironment";
import EnsuringResults from "./components/AccreditationB/EnsuringResults/EnsuringResults";
import Equipment from "./components/AccreditationB/Equipment/Equipment";
import ReagentsConsumables from "./components/AccreditationB/ReagentsConsumables/ReagentsConsumables";
import ProcessRequirements from "./components/AccreditationB/ProcessRequirements/ProcessRequirements";
import Personnel from "./components/AccreditationB/Personnel/Personnel";
import NonconformingWork from "./components/AccreditationB/NonconformingWork/NonconformingWork";
import RoleBasedDashboard from "./components/Dashboard/RoleBasedDashboard";
import LabsProfiles from "./components/LabMapping/LabsProfiles";
import Members from "./components/Members/Members";
import { useAuth } from "./context/AuthContext";
import AddEquipmentManagement from "./components/SLIPTAchecklist/EquipmentManagement/AddEquipmentManagement/AddEquipmentManagement";
import AddCustomerFocus from "./components/SLIPTAchecklist/CustomerFocus/AddCustomerFocus/AddCustomerFocus";
import AddInventoryManagement from "./components/SLIPTAchecklist/InventoryManagement/AddInventoryManagement/AddInventoryManagement";
import AddProcessManagement from "./components/SLIPTAchecklist/ProcessManagement/AddProcessManagement/AddProcessManagement";
import AddInformationManagement from "./components/SLIPTAchecklist/InformationManagement/AddInformationManagement/AddInformationManagement";
import AddNonConformingEvents from "./components/SLIPTAchecklist/NonConformingEvents/AddNonConformingEvents/AddNonConformingEvents";
import AddContinualImprovement from "./components/SLIPTAchecklist/ContinualImprovement/AddContinualImprovement/AddContinualImprovement";
import AddFacilitiesSafety from "./components/SLIPTAchecklist/FacilitiesSafety/AddFacilitiesSafety/AddFacilitiesSafety";
import AddAssessment from "./components/SLIPTAchecklist/Assessment/AddAssessment/AddAssessment";
import Assessment from "./components/SLIPTAchecklist/Assessment/Assessment";
import SyncManager from "./utils/SyncManager";
import axios from "axios";
import { env } from "./constants/env";
import { db } from "./utils/offlineDB";
import { prefetchAllQuestionnaires } from "./utils/prefetchQuestionnaires";
import { syncOfflineForms } from "./utils/syncOfflineForms";
import SyncService from "./utils/SyncService";
import { syncOfflineLabs } from "./utils/syncOfflineLabs";
import { prefetchLabs } from "./utils/prefetchLabs";
import { syncOfflineCertifications } from "./utils/syncOfflineCertifications";
import { prefetchCertificationsAndQuestionnaires } from "./utils/prefetchCertifications";
import { syncOfflineAccreditations } from "./utils/syncOfflineAccreditations";
import { prefetchAccreditations } from "./utils/prefetchAccreditations";
import DistributionOrders from "./components/DistributionOrders/DistributionOrders";
import { syncOfflineAuditSummaries } from "./utils/syncOfflineAuditSummaries";
import { prefetchAuditSummaries } from "./utils/prefetchAuditSummaries";
import PublicRoute from "./PublicRoute";

const LabDetailsWrapper = () => {
  const { user } = useAuth(); // assuming user.role exists

  const allSections = [
    { link: "profile", title: "Details" },
    { link: "infrastructure", title: "Laboratory infrastructure" },
    { link: "weekly-report", title: "Weekly report" },
    { link: "reports", title: "Communications & reports" },
    { link: "specimen-referral", title: "Specimen referral" },
    { link: "biosafety", title: "Biosafety & biosecurity" },
    { link: "logistics", title: "Logistics & supply chain management" },
    { link: "qms", title: "Quality management system" },
  ];

  // Only show "Details" for ASSESSOR and MINISTRY
  const visibleSections =
    user.role === "ASSESSOR"
      ? allSections.filter((s) => s.link === "profile")
      : allSections;

  return (
    <LabDetailsLayout
      backLink="/laboratory-mapping/labs"
      sections={visibleSections}
    />
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(false);

  const { token, user } = useAuth();


   // 🔔 ONLINE / OFFLINE TOASTS
  useEffect(() => {
    const handleOffline = () => {
      toast.warning("You are offline. Changes will be saved locally.", {
        toastId: "offline-toast", // prevents duplicates
        autoClose: false,
      });
    };

    const handleOnline = () => {
      toast.dismiss("offline-toast");
      toast.success("You are back online. Syncing data...", {
        toastId: "online-toast",
      });
    };

    // Initial state
    if (!navigator.onLine) {
      handleOffline();
    }

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  useEffect(() => {
    let mounted = true;

    const initOnlineFlow = async () => {
      if (!navigator.onLine || !user || !token) return;

      console.log("[OnlineFlow] Running full sync");

      try {
        // 1️⃣ Sync
        await syncOfflineForms(token);
        await syncOfflineLabs(token);
        await syncOfflineCertifications(token);
        await syncOfflineAccreditations(token);
        await syncOfflineAuditSummaries(token);

        if (!mounted) return;

        // 2️⃣ Prefetch
        await prefetchLabs(token);
        await prefetchCertificationsAndQuestionnaires(token);
        await prefetchAccreditations(token);
        await prefetchAuditSummaries(token);

        if (!mounted) return;

        // 3️⃣ Questionnaires
        if (user.labId) {
          await prefetchAllQuestionnaires(user.labId);
        }
      } catch (err) {
        console.error("[OnlineFlow] Failed:", err);
      }
    };

    // Register once
    SyncService.start(initOnlineFlow);

    return () => {
      mounted = false;
      SyncService.stop();
    };
  }, [user, token]);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  // useEffect(() => {
  //   // Sync immediately if already online
  //   if (navigator.onLine) {
  //     syncOfflineForms();
  //   }

  //   // Sync every time the app goes back online
  //   window.addEventListener("online", syncOfflineForms);

  //   return () => {
  //     window.removeEventListener("online", syncOfflineForms);
  //   };
  // }, []);

  if (isMobile) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>Mobile Not Supported</h2>
        <p>Please use a desktop device to access this application.</p>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />
      {/* <SyncManager /> */}
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        {/* <Route path="/sign-up" element={<SignUp />} /> */}
        {/* Public Route for unauthorized access redirection */}
        <Route path="/not-authorized" element={<Unauthorized />} />
        <Route path="/" element={<Layout />}>
          {/* Dashboard accessible to all authenticated roles */}
          <Route
            element={
              <ProtectedRoute
                allowedRoles={["LABORATORY", "ASSESSOR", "MINISTRY", "OWNER"]}
              />
            }
          >
            <Route path="/dashboard" element={<RoleBasedDashboard />} />
          </Route>

          {/* Routes for LABORATORY users (plus MINISTRY & OWNER) */}
          <Route
            element={
              <ProtectedRoute
                allowedRoles={[
                  "LABORATORY",
                  "ASSESSOR",
                  "MINISTRY",
                  "OWNER",
                  "HEALTH CENTER",
                  "ZAMMSA",
                ]}
              />
            }
          >
            <Route path="/laboratory-mapping">
              <Route path="labs" element={<LabsProfiles />} />
              <Route path="labs/:labId" element={<LabDetailsWrapper />}>
                <Route index element={<Navigate to="profile" replace />} />
                <Route path="profile" element={<Profile />} />
                <Route path="profile/edit-profile" element={<EditProfile />} />
                <Route path="infrastructure" element={<Infrastructure />} />
                <Route path="weekly-report" element={<WeeklyReport />} />
                <Route path="reports" element={<Reports />} />
                <Route
                  path="specimen-referral"
                  element={<SpecimenReferral />}
                />
                <Route path="biosafety" element={<Biosafety />} />
                <Route path="logistics" element={<LogisticsSupplyChain />} />
                <Route path="qms" element={<QualityManagementSystem />} />
              </Route>
              <Route path="profile" element={<Profile />} />
              <Route path="profile/edit-profile" element={<EditProfile />} />
              <Route path="infrastructure" element={<Infrastructure />} />
              <Route path="weekly-report" element={<WeeklyReport />} />
              <Route path="reports" element={<Reports />} />
              <Route path="specimen-referral" element={<SpecimenReferral />} />
              <Route path="biosafety" element={<Biosafety />} />
              <Route path="logistics" element={<LogisticsSupplyChain />} />
              <Route path="qms" element={<QualityManagementSystem />} />
            </Route>
          </Route>
          <Route
            element={
              <ProtectedRoute
                allowedRoles={["LABORATORY", "ASSESSOR", "OWNER"]}
              />
            }
          >
            <Route path="/certification">
              <Route path="slipta" element={<SLIPTAchecklist />} />
              <Route
                path="slipta/:labId"
                element={
                  <LabDetailsLayout
                    backLink="/certification/slipta"
                    sections={[
                      {
                        link: "audit-summary",
                        title: "Audit summary",
                      },
                      {
                        link: "documents",
                        title: "Documents & records",
                      },
                      {
                        link: "leadership",
                        title: "Organization & leadership",
                      },
                      {
                        link: "personnel",
                        title: "Personnel management",
                      },
                      {
                        link: "customer-focus",
                        title: "Customer focus",
                      },
                      {
                        link: "equipment",
                        title: "Equipment management",
                      },
                      {
                        link: "assessment",
                        title: "Assessment",
                      },
                      {
                        link: "inventory",
                        title: "Inventory management",
                      },
                      {
                        link: "process",
                        title: "Process management",
                      },
                      {
                        link: "information",
                        title: "Information management",
                      },
                      {
                        link: "non-conformities",
                        title: "Non conforming events",
                      },
                      {
                        link: "improvement",
                        title: "Continual improvement",
                      },
                      {
                        link: "facilities-safety",
                        title: "Facilities & safety",
                      },
                    ]}
                  />
                }
              >
                <Route
                  path="download-report"
                  element={<DownloadCertificationReportPage />}
                />
                <Route
                  index
                  element={<Navigate to="audit-summary" replace />}
                />
                {/* <Route path="lab-details" element={<LabDetails />} /> */}
                <Route path="audit-summary" element={<AuditSummary />} />
                <Route
                  path="audit-summary/add-audit-summary"
                  element={<AddAuditSummary />}
                />
                <Route path="documents" element={<DocumentsRecords />} />
                <Route
                  path="documents/add-documents-records"
                  element={<AddDocumentsRecords />}
                />
                <Route
                  path="documents/add-documents-records/:questionnaireId"
                  element={<AddDocumentsRecords />}
                />
                <Route path="leadership" element={<OrganizationLeadership />} />

                <Route
                  path="leadership/add-organization-leadership"
                  element={<AddOrganizationLeadership />}
                />
                <Route
                  path="leadership/add-organization-leadership/:questionnaireId"
                  element={<AddOrganizationLeadership />}
                />
                <Route path="personnel" element={<PersonnelManagement />} />
                <Route
                  path="personnel/add-personnel-management"
                  element={<AddPersonnelManagement />}
                />
                <Route
                  path="personnel/add-personnel-management/:questionnaireId"
                  element={<AddPersonnelManagement />}
                />
                <Route path="customer-focus" element={<CustomerFocus />} />
                <Route
                  path="customer-focus/add-customer-focus"
                  element={<AddCustomerFocus />}
                />
                <Route
                  path="customer-focus/add-customer-focus/:questionnaireId"
                  element={<AddCustomerFocus />}
                />
                <Route path="equipment" element={<EquipmentManagement />} />
                <Route
                  path="equipment/add-equipment-management"
                  element={<AddEquipmentManagement />}
                />
                <Route
                  path="equipment/add-equipment-management/:questionnaireId"
                  element={<AddEquipmentManagement />}
                />
                <Route path="assessment" element={<Assessment />} />
                <Route
                  path="assessment/add-assessment"
                  element={<AddAssessment />}
                />
                <Route
                  path="assessment/add-assessment/:questionnaireId"
                  element={<AddAssessment />}
                />
                <Route path="inventory" element={<InventoryManagement />} />
                <Route
                  path="inventory/add-inventory-management"
                  element={<AddInventoryManagement />}
                />
                <Route
                  path="inventory/add-inventory-management/:questionnaireId"
                  element={<AddInventoryManagement />}
                />
                <Route path="process" element={<ProcessManagement />} />
                <Route
                  path="process/add-process-management"
                  element={<AddProcessManagement />}
                />
                <Route
                  path="process/add-process-management/:questionnaireId"
                  element={<AddProcessManagement />}
                />
                <Route path="information" element={<InformationManagement />} />
                <Route
                  path="information/add-information-management"
                  element={<AddInformationManagement />}
                />
                <Route
                  path="information/add-information-management/:questionnaireId"
                  element={<AddInformationManagement />}
                />
                <Route
                  path="non-conformities"
                  element={<NonConformingEvents />}
                />
                <Route
                  path="non-conformities/add-nonconformities-events"
                  element={<AddNonConformingEvents />}
                />
                <Route
                  path="non-conformities/add-nonconformities-events/:questionnaireId"
                  element={<AddNonConformingEvents />}
                />
                <Route path="improvement" element={<ContinualImprovement />} />
                <Route
                  path="improvement/add-continual-improvement"
                  element={<AddContinualImprovement />}
                />
                <Route
                  path="improvement/add-continual-improvement/:questionnaireId"
                  element={<AddContinualImprovement />}
                />
                <Route
                  path="facilities-safety"
                  element={<FacilitiesSafety />}
                />
                <Route
                  path="facilities-safety/add-facilities-safety"
                  element={<AddFacilitiesSafety />}
                />
                <Route
                  path="facilities-safety/add-facilities-safety/:questionnaireId"
                  element={<AddFacilitiesSafety />}
                />
              </Route>
            </Route>
          </Route>

          {/* Routes for ASSESSOR users (plus MINISTRY & OWNER) */}
          <Route
            element={
              <ProtectedRoute
                allowedRoles={["LABORATORY", "ASSESSOR", "OWNER"]}
              />
            }
          >
            <Route path="/accreditation">
              <Route
                path=":accreditationName/:labId/download-report"
                element={<DownloadReportPage />}
              />
              <Route path="sadcas-f134-a" element={<AccreditationA />} />
              <Route
                path="sadcas-f134-a/:labId"
                element={
                  <LabDetailsLayout
                    backLink="/accreditation/sadcas-f134-a"
                    sections={[
                      // { link: "lab-details", title: "Details" },
                      { link: "introduction", title: "Introduction" },
                      {
                        link: "general-requirements",
                        title: "General requirements",
                      },
                      {
                        link: "governance-requirements",
                        title: "Structural & governance requirements",
                      },
                      {
                        link: "resource-requirements",
                        title: "Resource requirements",
                      },
                      {
                        link: "pre-examination-process",
                        title: "Pre examination process",
                      },
                    ]}
                  />
                }
              >
                {/* Redirect to lab-details when only /:labId is matched */}
                <Route index element={<Navigate to="introduction" replace />} />
                {/* <Route path="lab-details" element={<LabDetails />} /> */}
                <Route path="introduction" element={<Introduction />} />
                <Route
                  path="general-requirements"
                  element={<GeneralRequirements />}
                />
                <Route
                  path="governance-requirements"
                  element={<GovernanceRequirements />}
                />
                <Route
                  path="resource-requirements"
                  element={<ResourceRequirements />}
                />
                <Route
                  path="pre-examination-process"
                  element={<PreExaminationProcess />}
                />
              </Route>
              <Route path="sadcas-f134-b" element={<AccreditationB />} />
              <Route
                path="sadcas-f134-b/:labId"
                element={
                  <LabDetailsLayout
                    backLink="/accreditation/sadcas-f134-b"
                    sections={[
                      // { link: "lab-details", title: "Details" },
                      { link: "introduction-b", title: "Introduction" },
                      {
                        link: "reports-requirements",
                        title: "Requirements for reports",
                      },
                      {
                        link: "requests-examinations",
                        title: "Requests for providing laboratory examinations",
                      },
                      {
                        link: "sample-receipt",
                        title: "Sample receipt",
                      },
                      {
                        link: "facilities-environment",
                        title: "Facilities and environment",
                      },
                      {
                        link: "examination-processes",
                        title: "Examination processes",
                      },
                      {
                        link: "ensuring-results",
                        title: "Ensuring the validity of examination results",
                      },
                      {
                        link: "equipment",
                        title: "Equipment",
                      },
                      {
                        link: "reagents-consumables",
                        title: "Reagents and consumables",
                      },
                      {
                        link: "personnel",
                        title: "Personnel",
                      },
                      {
                        link: "process-requirements",
                        title: "Process requirements",
                      },
                      {
                        link: "nonconforming-work",
                        title: "Nonconforming work",
                      },
                    ]}
                  />
                }
              >
                {/* Redirect to lab-details when only /:labId is matched */}
                <Route
                  index
                  element={<Navigate to="introduction-b" replace />}
                />
                {/* <Route path="lab-details" element={<LabDetails />} /> */}
                <Route path="introduction-b" element={<IntroductionB />} />
                <Route
                  path="reports-requirements"
                  element={<ReportsRequirements />}
                />
                <Route
                  path="requests-examinations"
                  element={<RequestsExaminations />}
                />
                <Route path="sample-receipt" element={<SampleReceipt />} />
                <Route
                  path="facilities-environment"
                  element={<FacilitiesEnvironment />}
                />
                <Route
                  path="examination-processes"
                  element={<ExaminationProcesses />}
                />
                <Route path="ensuring-results" element={<EnsuringResults />} />
                <Route path="equipment" element={<Equipment />} />
                <Route
                  path="reagents-consumables"
                  element={<ReagentsConsumables />}
                />
                <Route path="personnel" element={<Personnel />} />
                <Route
                  path="process-requirements"
                  element={<ProcessRequirements />}
                />
                <Route
                  path="nonconforming-work"
                  element={<NonconformingWork />}
                />
              </Route>
            </Route>
          </Route>
          <Route
            element={<ProtectedRoute allowedRoles={["OWNER", "MINISTRY"]} />}
          >
            <Route path="members" element={<Members />} />
          </Route>
          <Route
            element={
              <ProtectedRoute
                allowedRoles={[
                  "OWNER",
                  "LABORATORY",
                  "HEALTH CENTER",
                  "ZAMMSA",
                  "MINISTRY",
                ]}
              />
            }
          >
            <Route
              path="/distribution-orders"
              element={<DistributionOrders />}
            />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
